<template>
  <div :class="[`wrapper-${type}-page`, `active-tab-${currentTab}`]">
    <div :class="[`wrapper-search-cover`]" :style="{ background }">
      <div class="section-1">&nbsp;</div>
      <div class="section-2">
        <LadSearchCover />
      </div>
      <div class="section-3">&nbsp;</div>
    </div>

    <div :class="[`wrapper-${type}-content`]">
      <el-container class="wrapper-main-content-tabs">
        <el-main>
          <LadAdvancedTabs
            :base="`${base}.tabs`"
            :tabs="tabs"
            :with-sticky="true"
            :sticky-options="{
              relative: '.wrapper-main-content-tabs',
              top: 60,
            }"
            :tabs-id="`country-search-tab`"
            :default-step="currentTab"
            @tab-click="handleClick"
            @current-tab="updateCurrentTab"
          />
        </el-main>
      </el-container>

      <el-container class="wrapper-main-content-with-aside">
        <el-main>
          <LadSearchTabDescription />

          <!-- <LadSearchTabTours /> -->

          <LadSearchTabFeaturedTours />

          <LadSearchTabRequirementsInfo :current-tab="currentTab" />

          <LadSearchTabTravelDeals />

          <LadSearchTabWhenToTravel />

          <LadSearchTabFaqs />
        </el-main>

        <el-aside v-if="!isMobile" width="auto">
          <LadAffix
            relative-element-selector=".wrapper-main-content-with-aside"
            :offset="{ top: 50, bottom: 20 }"
            :enabled="!isMobile"
          >
            <LadSearchCtaSidebar />
          </LadAffix>
        </el-aside>
      </el-container>
    </div>

    <div :class="[`wrapper-${type}-reviews`]">
      <el-container>
        <el-main>
          <LadSearchReviews />
        </el-main>
      </el-container>
    </div>

    <div :class="[`wrapper-${type}-info`]">
      <LadSearchRelatedTours />
    </div>

    <LadConfidence
      cache-prefix="lad-confidence"
      :cache-key="cacheKey"
      :with-cities="false"
    />
  </div>
</template>

<script>
import { mapState, mapGetters } from 'vuex'
import StaticMetaMixin from '@/utils/mixin/static-meta'
import LadSearchCover from '@/components/pages/search/country/sections/cover'
import LadAdvancedTabs from '@/components/advanced-tabs'
import { SEARCH_COUNTRY_TYPE_ROUTER } from '@/utils/static-router-alias'

export default {
  name: 'LadPageCountry',
  components: {
    LadSearchCover,
    LadAdvancedTabs,
    LadSearchTabDescription: () =>
      import(
        /* webpackChunkName: "lad-search-tab-description" */ '@/components/pages/search/country/tabs/description'
      ),
    // LadSearchTabTours: () =>
    //   import(
    //     /* webpackChunkName: "lad-search-tab-tours" */ '@/components/pages/search/country/tabs/tours'
    //   ),
    LadSearchTabFeaturedTours: () =>
      import(
        /* webpackChunkName: "lad-search-tab-featured-tours" */ '@/components/pages/search/country/tabs/featured-tours'
      ),
    LadSearchTabRequirementsInfo: () =>
      import(
        /* webpackChunkName: "lad-search-tab-requirements-info" */ '@/components/pages/search/country/tabs/requirements-info'
      ),
    LadSearchTabTravelDeals: () =>
      import(
        /* webpackChunkName: "lad-search-tab-travel-deals" */ '@/components/pages/search/country/tabs/travel-deals'
      ),
    LadSearchTabWhenToTravel: () =>
      import(
        /* webpackChunkName: "lad-search-tab-when-to-travel" */ '@/components/pages/search/country/tabs/when-to-travel'
      ),
    LadSearchTabFaqs: () =>
      import(
        /* webpackChunkName: "lad-search-tab-faqs" */ '@/components/pages/search/country/tabs/faqs'
      ),
    LadSearchReviews: () =>
      import(
        /* webpackChunkName: "lad-search-section-reviews" */ '@/components/pages/search/country/sections/reviews'
      ),
    LadSearchRelatedTours: () =>
      import(
        /* webpackChunkName: "lad-search-section-related-tours" */ '@/components/pages/search/country/sections/related-tours'
      ),
    LadConfidence: () =>
      import(
        /* webpackChunkName: "lad-confidence" */ '@/components/confidence'
      ),
    LadSearchCtaSidebar: () =>
      import(
        /* webpackChunkName: "lad-search-cta-sidebar" */ '@/components/pages/search/country/sections/cta-sidebar'
      ),
  },
  async asyncData({ app, store, route }) {
    await store.dispatch('country/getData', { country: route.params.value })

    const breadcrumb = []
    const items = store.state.country.breadcrumbs
    if (Object.keys(items).length > 0) {
      const keys = ['continent', 'country', 'city']

      keys.forEach((key) => {
        if (items[key]) {
          const to = {
            name: key === 'country' ? 'search-country' : 'search-type',
            params: {
              type: app.i18n.t(`router.search_type.type.${key}`),
              value: items[key].slug,
              tab:
                key === 'country'
                  ? null
                  : app.i18n.t('router.search_type.tab.tours'),
              travelTo: app.i18n.t('router.search_type.travel_to_'),
            },
          }

          breadcrumb.push({ to, text: items[key].name })
        }
      })
    }

    const to = {
      name: 'search-country',
      params: route.params,
    }

    breadcrumb.push({ to, text: store.state.country.header.name })

    await store.dispatch('app/setBreadcrumb', breadcrumb)
  },
  data() {
    return {
      type: 'country',
      tabs: [
        'description',
        // 'tours',
        'featured_tours',
        'requirements_info',
        'travel_deals',
        'when_to_travel',
        'faqs',
      ],
      currentTab: 'description',
    }
  },
  computed: {
    ...mapState('app', ['breadcrumb']),
    ...mapGetters('settings', ['language']),
    ...mapState('settings', ['currency']),
    ...mapGetters('device', ['isMobile']),
    ...mapState('country', {
      meta: (state) => ({
        title: state.metadata.title,
        description: state.metadata.description,
      }),
      header: (state) => ({
        media: {
          srcset: `${state.header.media.src
            .replace(/h=\d+/, 'h=1080')
            .replace(/q=\d+/, 'q=85')} 260`,
        },
      }),
      itemsSnippet(state) {
        const items = [].concat(state.outlet, state.tours, state.featured)

        return items.map((item, index) => {
          return {
            '@context': 'http://schema.org/',
            '@type': 'Product',
            name: item.title,
            image: item.media.data.url,
            description: item.description,
            mpn: item.permalink,
            aggregateRating: {
              '@type': 'AggregateRating',
              ratingValue: item.reviews.value || 3,
              reviewCount: item.reviews.count || 1,
            },
            availability: 'https://schema.org/InStock',
            priceCurrency: this.currency,
            price: item.total_amount.toFixed(2),
          }
        })
      },
      faqsSnippet: (state) => {
        const faqs = [].concat(
          state.faqs,
          state.travel_information,
          state.when_travel
        )

        return faqs.map((f) => ({
          '@type': 'Question',
          name: f.title,
          acceptedAnswer: {
            '@type': 'Answer',
            text: f.description,
          },
        }))
      },
      /** https://schema.org/TouristDestination */
      aggregateRatingSnippet: (state) => ({
        type: 'application/ld+json',
        json: {
          '@context': 'https://schema.org/',
          '@type': 'TouristDestination',
          additionalType: 'Country',
          name: state.metadata.title,
          description: state.metadata.description,
          image: state.header.media.src,

          // aggregateRating: {
          //   '@type': 'AggregateRating',
          //   ratingValue: state.country.average_score || 3.6,
          //   ratingCount: state.country.total_reviews || 1,
          // },

          // review: state.reviews.map((review) => ({
          //   '@type': 'Review',
          //   author: {
          //     '@type': 'Person',
          //     name: review._user.profile.fullname,
          //   },
          //   reviewBody: review.message,
          //   reviewRating: {
          //     '@type': 'Rating',
          //     ratingValue: review.score,
          //   },
          // })),
        },
      }),
      permalink: (state) => state.header.permalink,
      background: (state) =>
        `linear-gradient(rgba(0, 0, 0, 0.3), rgba(0, 0, 0, 0.3)), url('${state.header.media.src}') no-repeat center center/cover`,
    }),
    cacheKey() {
      return `search-${this.type}--${this.language}-${this.currency}--${
        this.isMobile ? 'm' : 'd'
      }`
    },
    base() {
      return `search.${this.type}`
    },
    breadcrumbSnippet() {
      const itemListElement = this.breadcrumb
        .map((_b, i) => {
          const { text, to } = _b

          if (to) {
            const href = this.$router.resolve(to).href

            return {
              '@type': 'ListItem',
              position: i + 1,
              name: text,
              item: `${process.env.APP_URL}${href}`,
            }
          }

          return null
        })
        .filter((item) => item)

      return {
        type: 'application/ld+json',
        json: {
          '@context': 'https://schema.org',
          '@type': 'BreadcrumbList',
          itemListElement,
        },
      }
    },
  },
  watch: {
    loading: {
      immediate: true,
      handler(newValue, oldValue) {
        this.$nuxt.$emit('custom-loading', {
          enabled: newValue,
          source: 'search',
        })
      },
    },
  },
  methods: {
    handleClick(tab, event) {},
    updateCurrentTab(tab) {
      this.currentTab = tab

      const index = tab.replace(/_/g, '-')

      this.$scrollTo(`#country-tab-${index}`, 500, {
        offset: -50,
      })
    },
  },
  head() {
    const staticMeta = StaticMetaMixin.head.call(this)
    let title = this.meta.title
    const description = this.meta.description

    title += ` | ${process.env.APP_NAME}`

    const meta = [
      {
        hid: 'og:title',
        property: 'og:title',
        content: title,
      },
      {
        hid: 'twitter:title',
        name: 'twitter:title',
        content: title,
      },
      {
        hid: 'og:description',
        property: 'og:description',
        content: description,
      },
      {
        hid: 'description',
        name: 'description',
        content: description,
      },
      {
        hid: 'twitter:description',
        property: 'twitter:description',
        content: description,
      },
    ]

    const others = staticMeta.meta.filter(
      (t) =>
        ![
          'og:title',
          'twitter:title',
          'og:description',
          'description',
          'twitter:description',
        ].includes(t.hid)
    )

    const language = process.env.APP_LOCALE.toLowerCase().split('_')[0]
    let baseType = null
    for (const [key, value] of Object.entries(
      SEARCH_COUNTRY_TYPE_ROUTER.alias[language]
    )) {
      if (value === this.$route.params.type) {
        baseType = key
      }
    }

    const link = [
      {
        hid: 'canonical',
        rel: 'canonical',
        href: `${process.env.APP_URL}${this.$route.path}`,
      },
      {
        hid: 'alternate-default',
        rel: 'alternate',
        hreflang: 'x-default',
        href: `${process.env.APP_URL_EN_US}/${SEARCH_COUNTRY_TYPE_ROUTER.alias.en[baseType]}/${SEARCH_COUNTRY_TYPE_ROUTER.travelTo.en}${this.permalink.en}`,
      },
      {
        hid: 'alternate-en',
        rel: 'alternate',
        hreflang: 'en',
        href: `${process.env.APP_URL_EN_US}/${SEARCH_COUNTRY_TYPE_ROUTER.alias.en[baseType]}/${SEARCH_COUNTRY_TYPE_ROUTER.travelTo.en}${this.permalink.en}`,
      },
      {
        hid: 'alternate-es',
        rel: 'alternate',
        hreflang: 'es',
        href: `${process.env.APP_URL_ES_MX}/${SEARCH_COUNTRY_TYPE_ROUTER.alias.es[baseType]}/${SEARCH_COUNTRY_TYPE_ROUTER.travelTo.es}${this.permalink.es}`,
      },
      {
        hid: 'alternate-es-CO',
        rel: 'alternate',
        hreflang: 'es-CO',
        href: `${process.env.APP_URL_ES_CO}/${SEARCH_COUNTRY_TYPE_ROUTER.alias.es[baseType]}/${SEARCH_COUNTRY_TYPE_ROUTER.travelTo.es}${this.permalink.es}`,
      },
    ]

    const script = [this.breadcrumbSnippet, this.aggregateRatingSnippet]

    if (this.itemsSnippet.length) {
      script.push({
        type: 'application/ld+json',
        json: {
          '@context': 'https://schema.org',
          '@type': 'ItemList',
          itemListElement: this.itemsSnippet,
        },
      })
    }

    if (this.faqsSnippet.length) {
      script.push({
        type: 'application/ld+json',
        json: {
          '@context': 'https://schema.org',
          '@type': 'FAQPage',
          mainEntity: this.faqsSnippet,
        },
      })
    }

    return {
      ...staticMeta,
      title,
      meta: [].concat(others, meta),
      link,
      script,
    }
  },
}
</script>

<style lang="scss">
.wrapper-country-page {
  .lad-tabs {
    .lad-el-tabs {
      .el-tabs__nav-wrap .el-tabs__nav {
        margin: 0;
        transition: all 0.5s ease;
      }
    }
  }

  .wrapper-main-content-tabs {
    .lad-tabs {
      .lad-el-tabs {
        .el-tabs__header {
          &.is-top {
            margin-bottom: 0;

            & + .el-tabs__content {
              padding-top: 40px;
            }

            &.sticky {
              max-width: 1130px;
            }
          }
        }
      }

      &.sticky-active {
        .el-tabs__header.sticky {
          .el-tabs__nav-wrap .el-tabs__nav {
            margin: 0 20px;
          }
        }
      }
    }
  }

  section[class*='wrapper-tab-'] {
    padding: 0;
    background-color: transparent;

    & + section {
      margin-top: 50px;
    }
  }

  .wrapper-country-reviews {
    background: rgba(249, 249, 249, 1);

    .reviews-grid {
      margin: 70px 0;
      justify-content: center;
    }
  }

  .wrapper-country-info {
    background: rgba(255, 255, 255, 1);
  }

  .subtitle-content {
    margin-top: 0;
    font-size: 32px;
    font-weight: 700;
    line-height: 42px;
  }

  .wrapper-main-content-with-aside {
    & > .el-aside {
      width: 310px !important;
      padding: 0 20px 0 0;
      box-sizing: border-box;
    }
  }

  /** only for demo */
  .wrapper-item-list {
    display: grid;
    grid-template-columns: repeat(3, 1fr);
    gap: 20px;

    .item-container {
      width: 100%;
      height: 415px;
      background-color: white;
      border-radius: 10px;
    }
  }

  @media screen and (max-width: 1170px) {
    .wrapper-main-content-tabs {
      .lad-tabs {
        &.sticky-active {
          .el-tabs__header.sticky {
            left: 0;
            right: 0;
            max-width: 100% !important;
          }
        }
      }
    }
  }

  @media screen and (max-width: 1026px) {
    .wrapper-main-content-with-aside {
      & > .el-main {
        order: 1;
        padding: 20px;
      }

      & > .el-aside {
        order: 2 !important;
        display: none;
      }
    }
  }

  @media screen and (max-width: 768px) {
    .wrapper-item-list {
      grid-template-columns: 1fr;
    }

    .search-wrapper--experiences-outlet {
      padding: 0;
    }

    .subtitle-content {
      font-size: 18px;
      line-height: 25px;
      margin-bottom: 30px;
    }
  }

  @media screen and (max-width: 700px) {
    .wrapper-main-content-tabs {
      padding-left: 20px;
      padding-right: 20px;
    }
  }
}
</style>
